import React from 'react';
import Skeleton from 'react-loading-skeleton';

import useTranslation, { format, formatJsx } from '../../hooks/useTranslation';

type Props = {
    isRefetching: boolean;
    numberOfEFakturas: number;
    formattedTotalAmount: string;
};

const MultipleApprovalEFAkturaListIntro: React.FC<Props> = ({
    isRefetching,
    numberOfEFakturas,
    formattedTotalAmount,
}) => {
    const translated = useTranslation();

    if (isRefetching)
        return (
            <div className="multi-approval-efaktura__list--intro">
                <Skeleton className="multi-approval-efaktura__list--intro-title skeleton" width={120} />
                <Skeleton className="multi-approval-efaktura__list--intro-button skeleton" height={28} width={80} />
            </div>
        );

    return (
        <div className="multi-approval-efaktura__list--intro">
            <h2 className="multi-approval-efaktura__list--intro-title light">
                {formatJsx(
                    translated.approveMultipleEFaktura.eFakturasWaiting,
                    <span className="bold">{numberOfEFakturas}</span>,
                )}
            </h2>
            {!isRefetching && (
                <div className="multi-approval-efaktura__list--intro-amount">
                    <span>{format(translated.approveMultipleEFaktura.subtotal, formattedTotalAmount)}</span>
                </div>
            )}
        </div>
    );
};

export default MultipleApprovalEFAkturaListIntro;
